import type { Middleware } from 'openapi-fetch';
import * as Sentry from "@sentry/browser";

const AUTH_ENDPOINTS = ['/token', '/user'];

export const SentryMiddleware: Middleware = {
  onRequest({ request }) {
    Sentry.addBreadcrumb({
      category: "log",
      message: `Network Request to ${request.url}`,
      level: "log",
    })
  },

  onResponse({ response }) {
    Sentry.addBreadcrumb({
      category: "log",
      message: `Network Response from ${response.url} with status ${response.status}`,
      level: "log",
    });
  },

  onError({ error, request }) {
    Sentry.addBreadcrumb({
      category: "log",
      message: `Network Error from ${request.url} stating ${error}`,
      level: AUTH_ENDPOINTS.some((ep) => request.url.includes(ep)) ? "log" : "error",
    });
  }
};

